import React, { useEffect } from "react";
import { Container } from "reactstrap";
import OnlyHeader from "components/Layout/OnlyHeader.js";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getCheckoutResponses } from "store/actions/checkoutQuestionAction";
import CheckoutResponsesTable from "components/CheckoutResponses/CheckoutResponsesTable";

const CheckoutResponses = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCheckoutResponses(id));
  }, [dispatch, id]);

  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <CheckoutResponsesTable />
      </Container>
    </>
  );
};

export default CheckoutResponses;
